<template>
  <div
    class="flex h-screen w-full flex-col justify-between bg-avu-gray font-avuText"
  >
    <div
      class="grid grid-rows-[repeat(2,minmax(33vw,auto))] lg:w-4/6 lg:grid-cols-3 lg:grid-rows-[repeat(2,20vw)]"
    >
      <div
        v-for="(digit, index) in splitErrorCode"
        :key="index"
        class="flex items-center justify-center font-bold text-white first:bg-avu-blue [&:nth-child(2)]:bg-avu-pink [&:nth-child(3)]:col-start-3 [&:nth-child(3)]:row-start-2 [&:nth-child(3)]:bg-avu-blue"
      >
        <span class="text-[37vw]/[26vw] lg:text-[23vw]/[17vw]">{{
          digit
        }}</span>
      </div>
    </div>

    <div
      class="mb-[88px] flex flex-col items-center justify-center font-avuText text-base text-avu-black md:text-2xl lg:ml-[85px] lg:items-start"
    >
      <h2>
        {{
          error.statusCode == "404"
            ? "The page could not be found."
            : error.message
        }}
      </h2>
      <NuxtLink
        to="/"
        class="underline underline-offset-[10px] transition duration-300 ease-in-out hover:text-avu-blue"
      >
        Please go back to homepage.
      </NuxtLink>
    </div>
  </div>
</template>

<script setup>
  import { computed } from "vue";
  const props = defineProps(["error"]);

  const splitErrorCode = computed(() => {
    return props.error?.statusCode?.toString().split("") || [];
  });
</script>
